module.exports = __webpack_public_path__ + "static/media/cq_cerca.765b4b87.svg";